import { appStyle } from '../style/app.style';

export const ENVIRONMENTS = {
  DEV: 'dev',
  PROD: 'prod',
};

export const PROCESS_ENVIRONMENTS = {
  DEV: 'development',
  PROD: 'production',
};

export const LEFT = 'left';
export const RIGHT = 'right';
export const DOWN = 'down';
export const UP = 'up';
export const BOTH = 'both';
export const MAX_OPTIONS_FOR_PROCESSING = 5;
export const TOP_LEFT_CORNER_INDEX = 0;
export const TOP_RIGHT_CORNER_INDEX = 1;
export const BOTTOM_RIGHT_CORNER_INDEX = 2;
export const BOTTOM_LEFT_CORNER_INDEX = 3;
export const INITIAL_X = 1000;
export const INITIAL_Y = 500;

export const SIDE_SIZE_MIN = 50;
export const SIDE_SIZE_MAX = 75;
export const FRONT_SIZE_MIN = 80;
export const FRONT_SIZE_MAX = 300;

export const INFILL_LOT_RECTANGLE_SIDE_SIZE_MIN = 50;
export const INFILL_LOT_RECTANGLE_SIDE_SIZE_MAX = 75;
export const INFILL_LOT_RECTANGLE_FRONT_SIZE_MIN = 50;
export const INFILL_LOT_RECTANGLE_FRONT_SIZE_MAX = 200;

export const CORNER_RECTANGLE_SIDE_SIZE_MIN = 50;
export const CORNER_RECTANGLE_SIDE_SIZE_MAX = 75;
export const CORNER_RECTANGLE_FRONT_SIZE_MIN = 90;
export const CORNER_RECTANGLE_FRONT_SIZE_MAX = 200;

export const CANVAS_DATA = {
  RULER_HEIGHT: 30,
  RULER_HEIGHT_OFFSET: 6,

  HIT_DOT_RADIUS: 7,
  HIT_DOT_STROKE_WIDTH: 2,
  HIT_DOT_STROKE_COLOR: 'red',
  HIT_DOT_FILL_COLOR: 'none',

  ANGLE_INDICATOR_RADIUS: 80,
  ANGLE_LABEL_BOTTOM_SPACE: 10,
  ANGLE_GUIDE_STROKE_WIDTH: 2,
  ANGLE_GUIDE_STROKE_COLOR: 'deepskyblue',
  ANGLE_GUIDE_LABEL_COLOR: 'deepskyblue',

  MAIN_LINE_STROKE_WIDTH: 5,
  MAIN_LINE_STROKE_COLOR: 'black',
  MAIN_TEXT_STROKE_COLOR: 'black',

  DRAWING_LINE_STROKE_WIDTH: 5,
  DRAWING_LINE_STROKE_COLOR: 'grey',

  DRAWING_GUIDE_STROKE_WIDTH: 2,
  DRAWING_GUIDE_STROKE_COLOR: 'lightgrey',

  PERP_GUIDE_STROKE_WIDTH: 2,
  PERP_GUIDE_STROKE_COLOR: 'red',

  HORIZONTAL_GUIDE_STROKE_WIDTH: 2,
  HORIZONTAL_GUIDE_STROKE_COLOR: 'lightgrey',

  DISTANCE_GUIDE_STROKE_WIDTH: 2,
  DISTANCE_GUIDE_STROKE_COLOR: 'green',
  DISTANCE_GUIDE_LABEL_COLOR: 'green',
  DISTANCE_INFO_TEXT_SIZE: '20px',
  WALLS_INFO_TEXT_SIZE: '25px',
  FLOOR_CONFIG_WALLS_INFO_TEXT_SIZE: '60px',
  UNITS_INFO_TEXT_SIZE: '25px',
};
export const EDIT = 'EDIT';
export const VIEW_ONLY = 'VIEW_ONLY';
export const DRAWING = 'DRAWING';

export const DOORS_DATA = {
  NODE_NAME: 'doors',
  WIDTH: 90,
  THICKNESS: 8,
  FILL_COLOR: 'grey',
  BORDER_WIDTH: 2,
  BORDER_COLOR: 'black',
  POSITION_NODE: 'position',
  DIRECTION_NODE: 'direction',
  HINGE_NODE: 'hinge',
  INTERNAL_HINGE_NODE: 'internalHinge',
  WIDTH_NODE: 'width',
  OPEN_DEGREE: 60,
};

export const INITIAL_STROKE_WIDTH = 5;

export const START_POINT_NODE = 'startPt';
export const END_POINT_NODE = 'endPt';
export const WALL_ID_NODE = 'wallId';
export const WALL_LOCATION_NODE = 'location';
export const WALL_STYLE_NODE = 'style';
export const WALL_SVG_SIZE = {
  STATIC_RECTANGLE_SIZE: '300px',
  STATIC_L_SHAPE_SIZE: '500px',
  NORMAL: '100%',
  MEDIUM: '100%',
  BIG: '1000px',
};

export const RECTANGLE = 'rectangle';
export const L_SHAPE = 'lShape';

export const DIAGONAL = 'diagonal';
export const ZERO = 'zero';

export const LINE_DATA = {
  START_POINT_NODE_NAME: 'startPoint',
  END_POINT_NODE_NAME: 'endPoint',
};

export const WALL_DATA = {
  NODE_NAME: 'walls',
  START_POINT_NODE_NAME: 'startPt',
  END_POINT_NODE_NAME: 'endPt',
  HIDDEN_NODE_NAME: 'hidden',
  TYPES: {
    EXTERNAL: 'external',
    EXTERNAL_WINDOW: 'externalWindow',
    INTERNAL: 'internal',
    CORRIDOR: 'corridor',
    UNIT: 'unit',
    STAIRCASE: 'staircase',
    ELEVATOR: 'elevator',
    TRASH_ROOM: 'trashRoom',
    SERVICE_ROOM: 'serviceRoom',
  },
  COLORS: {
    SHADOW: {
      INTERNAL: 'grey',
      WALLS: 'red',
      STROKE: 'transparent',
      FILL: 'grey',
      OVERLAP: appStyle.colors.blue,
      OPACITY: 0.5,
    },
  },
  WIDTH: {
    SHADOW: {
      STROKE: 0,
    },
  },
};

export const CORRIDOR_DATA = {
  ERROR: 'This corridor movement is not allowed.',
  NODE_NAME: 'corridors',
  UPDATE_PRECISION_FT: 1,
  MINIMAL_CORRIDOR_LENGTH_FOR_SIDEWAYS_UPDATES: 4,
  INTERNAL_WIDTH: 66,
  COLORS: {
    SHADOW: {
      INTERNAL: 'grey',
      WALLS: 'red',
      STROKE: 'transparent',
      FILL: 'grey',
      OPACITY: 0.5,
    },
  },
};

export const TYPES_READABLE_NAME = {
  [WALL_DATA.TYPES.EXTERNAL]: 'external',
  [WALL_DATA.TYPES.EXTERNAL_WINDOW]: 'External window',
  [WALL_DATA.TYPES.INTERNAL]: 'Internal',
  [WALL_DATA.TYPES.CORRIDOR]: 'Corridor',
  [WALL_DATA.TYPES.UNIT]: 'Unit',
  [WALL_DATA.TYPES.STAIRCASE]: 'Staircase',
  [WALL_DATA.TYPES.ELEVATOR]: 'Elevator',
  [WALL_DATA.TYPES.TRASH_ROOM]: 'Trash room',
  [WALL_DATA.TYPES.SERVICE_ROOM]: 'Service room',
};

export const WINDOWS_DATA = {
  NODE_NAME: 'windows',
  WIDTH: 90,
  THICKNESS: 8,
  BORDER_COLOR: 'black',
  FILL_COLOR: 'lightblue',
  BORDER_WIDTH: 2,
  WIDTH_NODE: 'width',
};

export const STEPS = {
  DRAW: 0,
  WINDOWS: 1,
  CORES_STAIRCASE: 2,
  CORES_ELEVATORS: 3,
  CORES_TRASH_ROOMS: 4,
  UNIT_LAYOUT: 5,
  RESULT: 6,
};

export const STEPPER_STEPS = {
  PROPERTIES: 1,
  SHAPE: 2,
  WALLS: 3,
  CORE: 4,
  UNITS: 5,
  RESULT: 6,
};

export const FORM_STEPS = {
  CREATE_BUILDING: 1,
  BUILDING_SHAPE: 2,
  BUILDING_DIMENSIONS: 3,
  CORES_CONFIG: 4,
};

export const NONE_SEQUENCE_API_CALLS = {
  REVIT: {
    DOWNLOAD: 'download',
    START_PROCESS: 'new',
  },
  PY: {},
  JS: {
    UNIT_CONSTRAINTS: 'roomsLayout',
  },
};

export const ELEVATORS_DATA = {
  NODE_NAME: 'elevators',
  UPDATE_PRECISION_FT: 1,
  TYPE_NAME: 'elevator',
};

export const STAIRCASES_DATA = {
  NODE_NAME: 'staircases',
  UPDATE_PRECISION_FT: 1,
  TYPE_NAME: 'staircase',
};

export const TRASH_ROOMS_DATA = {
  NODE_NAME: 'trashRooms',
  UPDATE_PRECISION_FT: 1,
  TYPE_NAME: 'trashRoom',
};

export const SERVICE_ROOMS_DATA = {
  NODE_NAME: 'serviceRooms',
  UPDATE_PRECISION_FT: 1,
  TYPE_NAME: 'serviceRoom',
};

export const SERVICE_ROOM_TYPES = {
  CLOSET: 'Closet',
};

export const UNIT_CONSTRAINTS_DATA = {
  NODE_NAME: 'constraints',
  ROOMS_SUB_NODE_NAME: 'rooms',
  EDGES_SUB_NODE_NAME: 'edges',
  UNIT_SEPARATORS_NODE_NAME: 'unitsSeparators',
  BORDER_WIDTH: 2,
  BORDER_COLOR: 'red',
  FILL_COLOR: 'yellow',
};

// TODO - do we also need UNIT_CONSTRAINTS_DATA?
export const UNITS_DATA = {
  NODE_NAME: 'units',
  BORDER_WIDTH: 3,
  BORDER_COLOR: 'yellow',
  FILL_COLOR: 'none',
  UNIT_PROPERTIES: {
    MIN_POSSIBLE_AREA: 'Minimum Square Foot',
    MAX_AREA_FOR_PROFIT: 'Target Square Foot',
    MAX_POSSIBLE_AREA: 'Maximum Square Foot',
  },
};

export const ROOMS_DATA = {
  NODE_NAME: 'rooms',
  BORDER_WIDTH: 2,
  BORDER_COLOR: 'black',
  FILL_COLOR: '#7CA7BF',
  OPACITY: 1,
  ROUND_PLUS_COLOR: 'grey',
};

export const EDGES_DATA = {
  NODE_NAME: 'edges',
  BORDER_WIDTH: 3,
  BORDER_COLOR: '#3bd277',
};

export const BUILDING_CORES_DATA = {
  NODE_NAME: 'buildingCores',
  BORDER_WIDTH: 2,
  BORDER_COLOR: '#df91f3',
  TEXT_COLOR: '#df91f3',
  START_POINT_NODE: 'startPt',
  END_POINT_NODE: 'endPt',
  TYPE_NODE: 'type',
  OBLIGATORY_NODE: 'obligatory',
  CORES_MINIMUM_STEP: STEPS.CORES_STAIRCASE,
  CORES_MAXIMUM_STEP: STEPS.CORES_TRASH_ROOMS,
  // TODO - get this from the managed data instead.
  MINIMUM_WIDTH: 48,
  TYPES: {
    [STEPS.CORES_STAIRCASE]: 'staircase',
    [STEPS.CORES_ELEVATORS]: 'elevator',
    [STEPS.CORES_TRASH_ROOMS]: 'shoot',
  },
  LIMIT_NODES: {
    [STEPS.CORES_STAIRCASE]: 'numberOfWantedStaircase',
    [STEPS.CORES_ELEVATORS]: 'numberOfWantedElevators',
    [STEPS.CORES_TRASH_ROOMS]: 'numberOfWantedTrashRooms',
  },
  TYPES_NAMES: {
    [STEPS.CORES_STAIRCASE]: 'staircase\\s',
    [STEPS.CORES_ELEVATORS]: 'elevator\\s',
    [STEPS.CORES_TRASH_ROOMS]: 'trash room\\s',
    [STEPS.UNIT_LAYOUT]: 'unit calculator',
    [STEPS.RESULT]: 'result',
  },
};

export const PUBLIC_COMPONENTS = {
  ID_PREFIX: {
    CORRIDOR: 'corridors',
    STAIRCASE: 'staircases',
    ELEVATOR: 'elevators',
    TRASH_ROOM: 'trashRooms',
    WALLS: 'outerWalls',
    SERVICE_ROOM: 'serviceRooms',
  },
};

export const GRID = {
  BORDER_WIDTH: 1,
  BORDER_WIDTH_THICK: 3,
  BORDER_COLOR: 'gainsboro',
  TEXT_COLOR: 'black',
};

export const CONVERSIONS = {
  FEET_TO_INCH: 12,
  METER_TO_CM: 100,
};

export const ORIENTATION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  DIAGONAL,
  ZERO,
};

export const DIRECTIONS = {
  LEFT,
  RIGHT,
  UP,
  DOWN,
  [ORIENTATION.HORIZONTAL]: [LEFT, RIGHT],
  [ORIENTATION.VERTICAL]: [UP, DOWN],
  BOTH,
};

export const DOOR_LOCATIONS_VALUE = {
  UL: 'UL',
  UR: 'UR',
  DL: 'DL',
  DR: 'DR',
  LU: 'LU',
  LD: 'LD',
  RU: 'RU',
  RD: 'RD',
};

export const MIRRORED_DOORS_LOCATION_MAP = {
  [DOOR_LOCATIONS_VALUE.UL]: DOOR_LOCATIONS_VALUE.DL,
  [DOOR_LOCATIONS_VALUE.DL]: DOOR_LOCATIONS_VALUE.UL,
  [DOOR_LOCATIONS_VALUE.UR]: DOOR_LOCATIONS_VALUE.DR,
  [DOOR_LOCATIONS_VALUE.DR]: DOOR_LOCATIONS_VALUE.UR,
  [DOOR_LOCATIONS_VALUE.LU]: DOOR_LOCATIONS_VALUE.LD,
  [DOOR_LOCATIONS_VALUE.LD]: DOOR_LOCATIONS_VALUE.LU,
  [DOOR_LOCATIONS_VALUE.RU]: DOOR_LOCATIONS_VALUE.RD,
  [DOOR_LOCATIONS_VALUE.RD]: DOOR_LOCATIONS_VALUE.RU,
};

// TODO - find a better name and refactor all code functions accordingly
export const DOOR_LOCATIONS = {
  [ORIENTATION.HORIZONTAL]: {
    [DIRECTIONS.UP]: {
      UL: DOOR_LOCATIONS_VALUE.UL,
      UR: DOOR_LOCATIONS_VALUE.UR,
    },
    [DIRECTIONS.DOWN]: {
      DL: DOOR_LOCATIONS_VALUE.DL,
      DR: DOOR_LOCATIONS_VALUE.DR,
    },
  },
  [ORIENTATION.VERTICAL]: {
    [DIRECTIONS.LEFT]: {
      LU: DOOR_LOCATIONS_VALUE.LU,
      LD: DOOR_LOCATIONS_VALUE.LD,
    },
    [DIRECTIONS.RIGHT]: {
      RU: DOOR_LOCATIONS_VALUE.RU,
      RD: DOOR_LOCATIONS_VALUE.RD,
    },
  },
};

export const UNIT_TYPES = {
  STUDIO: 'studio',
  BR_1: 'BR-1',
  BR_2: 'BR-2',
  BR_3: 'BR-3',
  BR_4: 'BR-4',
  BR_5: 'BR-5',
  BR_6: 'BR-6',
  BR_7: 'BR-7',
  BR_8: 'BR-8',
  BR_9: 'BR-9',
  BR_10: 'BR-10',
};

export const UNIT_TYPES_UNITS_INFO = {
  STUDIO: 'Studio',
  BR_1: '1-BR',
  BR_2: '2-BR',
  BR_3: '3-BR',
  BR_4: '4-BR',
  BR_5: '5-BR',
  BR_6: '6-BR',
  BR_7: '7-BR',
  BR_8: '8-BR',
  BR_9: '9-BR',
  BR_10: '10-BR',
};

export const UNIT_TYPES_TITLE = {
  STUDIO: 'Studio',
  BR_1: '1 BR',
  BR_2: '2 BR',
  BR_3: '3 BR',
};

export const UNIT_DATA = {
  TYPES_TO_NUMBER_OF_ROOMS: {
    [UNIT_TYPES.STUDIO]: 1,
    [UNIT_TYPES.BR_1]: 2,
    [UNIT_TYPES.BR_2]: 3,
    [UNIT_TYPES.BR_3]: 4,
    [UNIT_TYPES.BR_4]: 5,
    [UNIT_TYPES.BR_5]: 6,
    [UNIT_TYPES.BR_6]: 7,
    [UNIT_TYPES.BR_7]: 8,
    [UNIT_TYPES.BR_8]: 9,
    [UNIT_TYPES.BR_9]: 10,
    [UNIT_TYPES.BR_10]: 11,
  },
  TYPES_NAMES: {
    [UNIT_TYPES.STUDIO]: 'Studio',
    [UNIT_TYPES.BR_1]: '1-BR',
    [UNIT_TYPES.BR_2]: '2-BR',
    [UNIT_TYPES.BR_3]: '3-BR',
    [UNIT_TYPES.BR_4]: '4-BR',
    [UNIT_TYPES.BR_5]: '5-BR',
    [UNIT_TYPES.BR_6]: '6-BR',
    [UNIT_TYPES.BR_7]: '7-BR',
    [UNIT_TYPES.BR_8]: '8-BR',
    [UNIT_TYPES.BR_9]: '9-BR',
    [UNIT_TYPES.BR_10]: '10-BR',
  },
};

export const MESSAGE_TYPES = {
  POST: 'post',
  GET: 'get',
  DELETE: 'delete',
  PATCH: 'patch',
};

export const REVIT_API_STATUS_RESPONSE = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  PENDING: 'pending',
};

export const MODAL = {
  UNIT_PROPERTIES: 'MW-1',
  CORE_CONFIG: 'MW-2',
  WALL_CONFIG: 'MW-3',
  TYPICAL_CONFIG: 'MW-4',
  CONFIRM_DIALOG: 'MW-5',
  UNITS_MIX: 'MW-6',
  CONTROL_DIALOG: 'MW-7',
};

export const CANVAS = {
  CANVAS_WIDTH: '100%',
  CANVAS_HEIGHT: '100%',
  CANVAS_NORMAL: '300px',
  IN_UNIT_MODAL_WIDTH: 700,
  IN_UNIT_MODAL_HEIGHT: 420,
  ANGLE_RESOLUTION: 90,
  RESOLUTION: 1,
  LINE_SCALE: 0.5,
};

// Typical Floor Modal
export const BTN_ACT = {
  OK: 'Ok',
  CLOSE: 'X',
  CLONE_TYPE: 'Clone this type?',
  REMOVE_TYPE: 'Remove this type?',
  TYPICAL_FLOOR: 'typical-floor-modal',
};

export const POLYGON = {
  DIRECTION: {
    CLOCKWISE: 'CLOCKWISE',
    COUNTER_CLOCKWISE: 'COUNTER_CLOCKWISE',
  },
  MAX_NUMBER_OF_POINTS: 64, // arbitrary number defines the must sophisticated polygon supported.
  MAX_DISTANCE_FROM_CENTER: 12 * 2 * Math.sqrt(10 ** 2 + 10 ** 2), // TODO - get this from the managedData by unit type.
};

export const OPTION = {
  TYPES: {
    MOVE_CORE: 'MOVE_CORE',
    ROTATE_CORE: 'ROTATE_CORE',
    MIRROR_CORE: 'MIRROR_CORE',
    UPDATE_DOORS: 'UPDATE_DOORS',
    MOVE_CORRIDOR_TIP: 'MOVE_CORRIDOR_TIP',
    MOVE_ENTIRE_CORRIDOR: 'MOVE_ENTIRE_CORRIDOR',
    MOVE_WALL: 'MOVE_WALL',
    SPLIT_OUTER_WALL: 'SPLIT_OUTER_WALL',
    SPLIT_UNIT_WALL: 'SPLIT_UNIT_WALL',
    APPLY_WALLS_CHANGED: 'MOVE_ALL_WALL',
    MERGE_TWO_UNITS: 'MERGE_TWO_UNITS',
    REMOVE_DOOR_BY_HELPER_WALL: 'REMOVE_DOOR_BY_HELPER_WALL',
    REMOVE_ROOM: 'REMOVE_ROOM',
    REMOVE_WALL: 'REMOVE_WALL',
    ADD_NEW_CORE: 'ADD_NEW_CORE',
    REMOVE_CORE: 'REMOVE_CORE',
    UPDATE_OUTER_WALL_TYPE: 'UPDATE_OUTER_WALL_TYPE',
  },
};

export const RELATIVE_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
};

export const CURRENCY = {
  USD: '$',
};

export const WALLS_TEMPLATE = {
  id: Number.NEGATIVE_INFINITY,
  type: undefined,
  startPt: undefined,
  endPt: undefined,
  hidden: false,
  helperWall: false,
  outerWall: false,
  legalWindowWall: false,
  baseOffset: 0,
  arc: 0,
  errors: [],
};

export const CORE_NODE_NAMES = [
  ELEVATORS_DATA,
  STAIRCASES_DATA,
  TRASH_ROOMS_DATA,
  SERVICE_ROOMS_DATA,
].map(({ NODE_NAME }) => NODE_NAME);
export const CORE_TYPES = [
  ELEVATORS_DATA,
  STAIRCASES_DATA,
  TRASH_ROOMS_DATA,
  SERVICE_ROOMS_DATA,
].map(({ TYPE_NAME }) => TYPE_NAME);
export const CORE_DATA = [ELEVATORS_DATA, STAIRCASES_DATA, TRASH_ROOMS_DATA, SERVICE_ROOMS_DATA];

// Doors
export const HELPER_WALL = {
  RADIUS_DIVIDER: 2,
  SIZE_DIVIDER: 1.5,
  COLOR: 'brown',
};

// Prevent for count undoHistory
export const COUNT_HISTORY_PREVENT = 50;

export const MANUAL_INSTRUCTIONS = {
  [FORM_STEPS.CREATE_BUILDING]: {
    title: 'Properties',
    instructions: 'Please fill in the properties of the building',
  },
  [FORM_STEPS.BUILDING_SHAPE]: {
    title: 'Shape',
    instructions: 'Select a building shape',
  },
  [FORM_STEPS.BUILDING_DIMENSIONS]: {
    title: 'Walls',
    instructions: 'Insert building dimensions',
  },
  [FORM_STEPS.CORES_CONFIG]: {
    title: 'Templates',
    instructions: 'Select 1 or more preferred layouts.',
  },
};

export const STEPS_DETAILS = {
  [STEPS.DRAW]: {
    title: 'Create new building',
    instructions: 'Please choose the dimensions and properties of the building',
  },
  [STEPS.WINDOWS]: {
    title: 'Floor Layout',
    instructions:
      'Split, move and modify wall types if needed. Click "Next" to continue.',
  },
  [STEPS.CORES_STAIRCASE]: {
    title: 'Corridor length & location',
    instructions: 'Adjust the corridor location and length if needed.',
  },
  [STEPS.CORES_ELEVATORS]: {
    title: 'Staircases location',
    instructions: 'Select preferred layout(s). Zoom into any layout to adjust.',
  },
  [STEPS.CORES_TRASH_ROOMS]: {
    title: 'Elevators location',
    instructions: 'Select preferred layout(s). Zoom into any layout to adjust.',
  },
  [STEPS.UNIT_LAYOUT]: {
    title: 'Units',
    instructions: 'Select preferred layout(s).',
  },
  [STEPS.RESULT]: {
    title: 'Compare',
    instructions:
      'Select preferred layout(s). Zoom into a layout to review, print and download.',
    instructions_for_single_option: 'Download selected plan.',
  },
};

export const STEP_TYPES = {
  [STEPPER_STEPS.PROPERTIES]: 'Properties',
  [STEPPER_STEPS.SHAPE]: 'Shape',
  [STEPPER_STEPS.WALLS]: 'Walls',
  [STEPPER_STEPS.CORE]: 'Core',
  [STEPPER_STEPS.UNITS]: 'Units',
  [STEPPER_STEPS.RESULT]: 'Result',
};

// options for download file
export const DOWNLOAD_OPTIONS = {
  ZIP: 'zip',
  JSON: 'json',
};

export const DEVELOPMENT_MODE = {
  COUNT: 5,
};

export const WALLS_WITH_DOUBLE_ARROWS = [
  WALL_DATA.TYPES.EXTERNAL,
  WALL_DATA.TYPES.EXTERNAL_WINDOW,
  WALL_DATA.TYPES.UNIT,
];

export const SELECTED_STATIC_TYPES = {
  ALL_UNIT: 'allUnit',
};

export const SHADOW_RECTANGLE_STROKE = 3;
export const MINIMAL_DISTANCE_BETWEEN_POINT_AND_CORRIDOR_WALL = 50;
export const DEFAULT_FLOOR_HEIGHT = 120;

export const TOP_LEFT_POINT = { x: 0, y: 0 };
export const FRONT_LOT_LINE = 'street';
export const REAR_LOT_LINE = 'rear';
export const SIDE_LOT_LINE = 'side';

export const LOT = {
  TYPES: {
    INFILL_LOT: 'INFILL_LOT',
    CORNER_LOT: 'CORNER_LOT',
    TWO_CORNER_LOT: 'TWO_CORNER_LOT',
    THROUGH_LOT: 'THROUGH_LOT',
    ENTIRE_BLOCK: 'ENTIRE_BLOCK',
    IRREGULAR: 'IRREGULAR',
  },
  NAMES: {
    INFILL_LOT: 'Interior Lot',
    CORNER_LOT: 'Corner Lot',
    TWO_CORNER_LOT: 'Two Corner Lot',
    THROUGH_LOT: 'Through Lot',
    ENTIRE_BLOCK: 'Entire Block',
    IRREGULAR: 'Irregular',
  },
};

export const BUILDING = {
  TYPES: {
    RIGHT_CORNER_RECT: 'RIGHT_CORNER_RECT',
    LEFT_CORNER_RECT: 'LEFT_CORNER_RECT',
    INFILL_RECT: 'INFILL_RECT',
    THROUGH_RECT: 'THROUGH_RECT',
    RIGHT_CORNER_LSHAPE: 'RIGHT_CORNER_LSHAPE',
    LEFT_CORNER_LSHAPE: 'LEFT_CORNER_LSHAPE',
    USHAPE: 'USHAPE',
  },
};

export const REG_NUMBER = /^-?\d*\.?\d*$/;
